/**
 * BFCM 2026 全页共用脚本
 * 负责：阶段同步、倒计时、锚点导航、复制码、活动态、Tab、Bundle、Finder、弹窗、图片适配
 */
(function () {
  'use strict';

  var rootSel = '.bfcm2026';
  var tz = '-08:00';

  // 读取壳层配置
  function getConfig() {
    var el = document.getElementById('bfcm2026-config');
    if (!el) return { phase: 'early', dealState: 'auto' };
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return { phase: 'early', dealState: 'auto' };
    }
  }

  // 同步 phase / logged 到所有区块根节点
  function syncRoots(cfg) {
    document.querySelectorAll(rootSel).forEach(function (el) {
      el.dataset.phase = cfg.phase || 'mega';
      if (document.documentElement.classList.contains('bfcm2026-customer')) {
        el.classList.add('is-logged');
      }
    });
  }

  // Toast 提示
  function toast(msg) {
    var t = document.getElementById('bfcm2026-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('on');
    setTimeout(function () {
      t.classList.remove('on');
    }, 1800);
  }

  // 活动区块 upcoming / live / ended：区块手动状态优先，否则按日期
  function applyStates(mode) {
    document.querySelectorAll('[data-start][data-end]').forEach(function (s) {
      var forced = s.getAttribute('data-deal-state');
      var a = new Date(s.dataset.start + 'T00:00:00' + tz);
      var b = new Date(s.dataset.end + 'T23:59:59' + tz);
      var n = new Date();
      var st;
      if (forced && forced !== 'auto') {
        st = forced;
      } else if (mode && mode !== 'auto') {
        st = mode;
      } else {
        st = n < a ? 'upcoming' : n > b ? 'ended' : 'live';
      }
      s.dataset.state = st;
    });
  }

  // 倒计时
  function initCountdown(cfg) {
    var cd = document.getElementById('cd');
    var label = document.getElementById('cdLabel');
    // 读屏播报用的空 live region（见 hero.liquid）；只在悬停/聚焦时写入一次
    var sr = document.getElementById('cdSr');
    var wrap = document.getElementById('cdWrap');
    if (!cd) return;
    // 后台勾掉「Show countdown」：整块隐藏且不启动计时器，不再读开始时间
    if (cfg.countdownOn === false) {
      document.documentElement.classList.add('bfcm2026-cd-off');
      return;
    }
    // 当前这句最新文案，随时更新但不主动播报
    var spokenNow = '';
    var end = new Date((cfg.countdownEnd || '2026-11-30T23:59:59') + tz);
    function tick() {
      var n = new Date();
      // 只倒计时到结束时间，文案固定用 Ends in（不再有 Starts in）
      var tgt = end;
      var lbl = cfg.labelEnds || 'Ends in';
      var s = Math.max(0, Math.floor((tgt - n) / 1000));
      var d = Math.floor(s / 86400);
      s %= 86400;
      var h = Math.floor(s / 3600);
      s %= 3600;
      var m = Math.floor(s / 60);
      s %= 60;
      var z = function (x) {
        return String(x).padStart(2, '0');
      };
      if (label) label.textContent = lbl;
      // 视觉层：父级已 aria-hidden，这里的每秒重写不会产生任何朗读噪音
      cd.innerHTML = [
        [z(d), 'Days'],
        [z(h), 'Hrs'],
        [z(m), 'Min'],
        [z(s), 'Sec'],
      ]
        .map(function (x) {
          return '<span class="cd-u"><b>' + x[0] + '</b><small>' + x[1] + '</small></span>';
        })
        .join('');

      // 整句：单位用完整单词（days / hours），缩写会被读成拼写
      spokenNow =
        lbl + ' ' +
        d + (d === 1 ? ' day' : ' days') + ', ' +
        h + (h === 1 ? ' hour' : ' hours') + ', ' +
        m + (m === 1 ? ' minute' : ' minutes') + ', ' +
        s + (s === 1 ? ' second' : ' seconds') + '.';
      // 这里只记录，不写进 DOM：写进去就等于每秒播报一次
    }

    // 开始播报：把当前这一秒的整句塞进 live region，读屏念一次
    var lastSpeak = 0;
    function speak() {
      if (!sr) return;
      // 触屏点按时浏览器会再补一次合成 mouseenter，这里去重，避免念两遍
      var now = Date.now();
      if (now - lastSpeak < 400) return;
      lastSpeak = now;
      sr.textContent = spokenNow;
    }

    // 停止播报：清空 live region。读屏会中止还没念完的那句，
    // 也让下一次悬停成为「从空到有」的真实变更。
    function hush() {
      if (sr) sr.textContent = '';
    }

    if (wrap) {
      // 只有真的支持 hover 的设备才绑鼠标进出；
      // 触屏设备绑了会被合成的 mouseenter/mouseleave 干扰（念一半就被清掉）
      var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
      if (canHover) {
        // 鼠标移入 → 念一次；移出 → 停。悬停期间不刷新，不会重复播报
        wrap.addEventListener('mouseenter', speak);
        wrap.addEventListener('mouseleave', hush);
      }
      // 键盘 Tab 过来同样念一次，离开焦点就停
      wrap.addEventListener('focusin', speak);
      wrap.addEventListener('focusout', hush);
      // 触屏没有 hover，点一下念一次
      wrap.addEventListener('touchstart', speak, { passive: true });
    }

    tick();
    setInterval(tick, 1000);
  }

  // 复制优惠码：成功后按钮改 Copied / 勾，不再弹 toast
  var COPY_CHECK_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l5 5L20 7"/></svg>';

  function copyCodeText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;left:-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (err) {
        reject(err);
      }
      document.body.removeChild(ta);
    });
  }

  function markCopyBtn(btn) {
    if (btn.classList.contains('is-copied')) return;
    btn.classList.add('is-copied');
    // 闪购码是图标按钮，换成勾；其余 Copy 文案改 Copied
    if (btn.classList.contains('fl-cc2')) {
      var svg = btn.querySelector('svg');
      if (svg) {
        btn.dataset.copySvg = svg.outerHTML;
        svg.outerHTML = COPY_CHECK_SVG;
      }
    } else {
      if (!btn.dataset.copyLabel) btn.dataset.copyLabel = (btn.textContent || 'Copy').trim();
      btn.textContent = 'Copied';
    }
    window.setTimeout(function () {
      btn.classList.remove('is-copied');
      if (btn.classList.contains('fl-cc2')) {
        var cur = btn.querySelector('svg');
        if (cur && btn.dataset.copySvg) cur.outerHTML = btn.dataset.copySvg;
      } else if (btn.dataset.copyLabel) {
        btn.textContent = btn.dataset.copyLabel;
      }
    }, 2000);
  }

  function initCopy() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-copy]');
      if (!b) return;
      var code = b.getAttribute('data-copy');
      if (!code) return;
      copyCodeText(code)
        .then(function () {
          markCopyBtn(b);
        })
        .catch(function () {});
    });
  }

  // 购物车接口地址（主题可能通过 window.routes 提供带语言前缀的路径）
  function cartUrls() {
    var r = window.routes || {};
    return { cart: r.cart_url || '/cart', add: r.cart_add_url || '/cart/add' };
  }

  // 打开侧边购物车：优先用主题自己的 renderContents（会一并刷新抽屉和购物车图标），
  // 没有现成 sections 时再拉一次；主题没有 cart-drawer 组件就退回购物车页面
  function openCartDrawer(cartState) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      window.location = cartUrls().cart;
      return Promise.resolve();
    }
    if (typeof cartDrawer.setActiveElement === 'function') {
      cartDrawer.setActiveElement(document.activeElement);
    }

    // 空车时元素上带 is-empty，会把 .drawer__inner 压成空态布局，加购后必须摘掉
    function render(sections) {
      cartDrawer.classList.remove('is-empty');
      if (typeof cartDrawer.renderContents === 'function' && sections['cart-drawer']) {
        cartDrawer.renderContents({ sections: sections, id: 0 });
        return;
      }
      // 主题没有 renderContents 时的兜底：手动替换抽屉内容再展开
      var html = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
      var newDrawer = html.querySelector('cart-drawer');
      if (newDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;
        var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
      }
      if (typeof cartDrawer.open === 'function') cartDrawer.open();
    }

    // 加购接口已经带回了 sections，直接用，省一次请求
    if (cartState && cartState.sections && cartState.sections['cart-drawer']) {
      render(cartState.sections);
      return Promise.resolve();
    }

    return fetch(cartUrls().cart + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (res) {
        return res.json();
      })
      .then(render)
      .catch(function (err) {
        console.error(err);
      });
  }

  // 批量加购：items 形如 [{ id: 123, quantity: 1 }]，顺带要回抽屉 sections
  function addCartItems(items) {
    return fetch(cartUrls().add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'] }),
      credentials: 'same-origin',
    }).then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    });
  }

  // 加购成功后通知主题其它组件刷新（购物车图标数量、抽屉条目等）
  function announceCartUpdate(source, cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: source, cartData: cartData });
    }
  }

  // 加购写入侧边购物篮并打开 cart-drawer
  function initBfcmAtc() {
    function resolveVariantId(btn) {
      var vid = btn.getAttribute('data-variant-id');
      if (vid) return Promise.resolve(vid);
      var handle = btn.getAttribute('data-product-handle');
      var url = btn.getAttribute('data-product-url') || '';
      if (!handle && url) {
        var m = url.match(/\/products\/([^/?#]+)/);
        if (m) handle = m[1];
      }
      if (!handle) return Promise.resolve('');
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (p) {
          if (!p) return '';
          if (p.variants && p.variants.length) {
            var avail = p.variants.find(function (v) {
              return v.available;
            });
            return String((avail || p.variants[0]).id);
          }
          return p.variants && p.variants[0] ? String(p.variants[0].id) : '';
        })
        .catch(function () {
          return '';
        });
    }

    function setAtcLoading(btn, on) {
      var spin = btn.querySelector('.loading__spinner');
      if (on) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        if (spin) spin.classList.remove('hidden');
      } else {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('loading');
        if (spin) spin.classList.add('hidden');
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bfcm-atc]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('loading')) return;
      setAtcLoading(btn, true);
      resolveVariantId(btn)
        .then(function (variantId) {
          if (!variantId) throw new Error('Missing variant');
          return addCartItems([{ id: Number(variantId), quantity: 1 }]);
        })
        .then(function (state) {
          announceCartUpdate('bfcm2026-atc', state);
          return openCartDrawer(state);
        })
        .catch(function (err) {
          console.error(err);
          var fallback = btn.getAttribute('data-product-url');
          if (fallback) window.location = fallback;
        })
        .finally(function () {
          setAtcLoading(btn, false);
        });
    });
  }

  // Sitewide / Member Tab 切换
  function initTabs() {
    document.querySelectorAll('.sw-tabs').forEach(function (tabs) {
      var grid = tabs.parentElement && tabs.parentElement.querySelector('.sw-grid');
      if (!grid) return;
      var panes = grid.querySelectorAll('[data-sw-tab]');
      function show(i) {
        // 用 contents 让产品卡直接参与 .sw-grid 布局；隐藏时彻底 display:none
        panes.forEach(function (p) {
          var on = String(p.getAttribute('data-sw-tab')) === String(i);
          p.hidden = !on;
          p.style.display = on ? 'contents' : 'none';
        });
        tabs.querySelectorAll('button').forEach(function (b) {
          var on = String(b.dataset.t) === String(i);
          b.classList.toggle('on', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      tabs.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-t]');
        if (b) show(b.dataset.t);
      });
      show(0);
    });

    // 会员 Tab
    document.querySelectorAll('#new .mb-tabs, .bfcm2026-member .mb-tabs').forEach(function (tabs) {
      var root = tabs.closest('.bfcm2026') || tabs.closest('section') || document;
      tabs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-mt]');
        if (!b) return;
        root.querySelectorAll('[data-mt]').forEach(function (x) {
          x.classList.toggle('on', x === b);
        });
        root.querySelectorAll('[data-mp]').forEach(function (p) {
          p.classList.toggle('on', p.dataset.mp === b.dataset.mt);
        });
      });
    });
  }

  // 积分卡 Redeem Now：打开左下角 Smile 兑换面板（与点击礼物 launcher 相同）
  function openSmileRedeemPanel() {
    if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
      window.SmileUI.openPanel({ deep_link: 'points_products' });
      return true;
    }
    var launcher =
      document.querySelector('.smile-launcher-frame') ||
      document.querySelector('#smile-ui-lite-launcher-frame') ||
      document.querySelector('[class*="smile-launcher"]');
    if (launcher && typeof launcher.click === 'function') {
      launcher.click();
      return true;
    }
    return false;
  }

  function initSmileRedeem() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bfcm-smile-redeem]');
      if (!btn) return;
      e.preventDefault();
      if (openSmileRedeemPanel()) return;
      document.addEventListener(
        'smile-ui-loaded',
        function () {
          openSmileRedeemPanel();
        },
        { once: true }
      );
    });
  }

  // 会员登录：当前标签页走同域网关，回来后滚到本模块
  var MEMBER_LOGIN_KEY = 'bfcm2026_login_return';

  function memberLoginStorageSet(which) {
    try {
      sessionStorage.setItem(MEMBER_LOGIN_KEY, which);
      localStorage.setItem(MEMBER_LOGIN_KEY, which);
    } catch (err) {}
  }

  function memberLoginStorageGet() {
    try {
      return sessionStorage.getItem(MEMBER_LOGIN_KEY) || localStorage.getItem(MEMBER_LOGIN_KEY);
    } catch (err) {
      return null;
    }
  }

  function memberLoginStorageClear() {
    try {
      sessionStorage.removeItem(MEMBER_LOGIN_KEY);
      localStorage.removeItem(MEMBER_LOGIN_KEY);
    } catch (err) {}
  }

  function memberLoginReturnPath(which) {
    var qs = new URLSearchParams(window.location.search);
    ['_ab', '_fd', '_sc', 'pb', 'key'].forEach(function (k) {
      qs.delete(k);
    });
    qs.set('bfcm_login', which);
    return window.location.pathname + '?' + qs.toString();
  }

  function bindMemberLoginSameTab() {
    var root = document.getElementById('new');
    if (!root) return;
    root.querySelectorAll('a[data-login], a[data-login-code]').forEach(function (link) {
      if (link.dataset.bfcmLoginBound) return;
      link.dataset.bfcmLoginBound = 'true';
      link.addEventListener('click', function (e) {
        var pane = link.closest('[data-mp]');
        var which = pane && pane.getAttribute('data-mp') === 'points' ? 'points' : 'member';
        memberLoginStorageSet(which);
        // 强制本标签跳转，覆盖 ADA 给外链加的 target=_blank
        e.preventDefault();
        window.location.assign(
          '/customer_authentication/login?return_to=' + encodeURIComponent(memberLoginReturnPath(which))
        );
      });
    });
  }

  function openMemberTab(which) {
    var root = document.getElementById('new');
    if (!root) return;
    var btn = root.querySelector('[data-mt="' + which + '"]');
    if (btn) btn.click();
  }

  function initMemberLoginReturn() {
    bindMemberLoginSameTab();
    var target = document.getElementById('new');
    if (!target) return;
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (err) {
      return;
    }
    var which = params.get('bfcm_login') || memberLoginStorageGet();
    if (which !== 'member' && which !== 'points') return;

    memberLoginStorageClear();
    if (which === 'points') openMemberTab('points');

    function headerOffset() {
      var maxBottom = 0;
      var nodes = document.querySelectorAll(
        '.shopify-section-group-header-group, .section-header, sticky-header, .header-wrapper, #qn'
      );
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.classList && el.classList.contains('shopify-section-header-hidden')) continue;
        var r = el.getBoundingClientRect();
        if (r.height < 1) continue;
        if (r.bottom > maxBottom) maxBottom = r.bottom;
      }
      return Math.max(0, maxBottom);
    }

    function scroll() {
      var top = target.getBoundingClientRect().top + window.scrollY - headerOffset() - 8;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
    requestAnimationFrame(scroll);
    setTimeout(scroll, 400);

    if (params.has('bfcm_login') && window.history && window.history.replaceState) {
      params.delete('bfcm_login');
      var q = params.toString();
      var next = window.location.pathname + (q ? '?' + q : '') + window.location.hash;
      window.history.replaceState({}, '', next);
    }
  }

  // 锚点导航：贴在吸顶头部下方，不要顶到视口最上
  function initJumpNav() {
    var qn = document.getElementById('qn');
    if (!qn) return;
    var qa = [].slice.call(qn.querySelectorAll('a[data-qn]'));
    var weeks = document.getElementById('weeks');
    // 取实际吸顶头底部（含公告栏），避免写死 top:68
    function headerEl() {
      return (
        document.querySelector('.section-header.shopify-section-header-sticky') ||
        document.querySelector('sticky-header') ||
        document.querySelector('.section-header') ||
        document.querySelector('.header-wrapper')
      );
    }
    function headerBottom() {
      // 只认视口里真实可见的头底边；头滚走/收起后贴顶，避免上方露内容缝
      var maxBottom = 0;
      var nodes = document.querySelectorAll(
        '.shopify-section-group-header-group, .section-header, sticky-header, .header-wrapper'
      );
      if (!nodes.length) {
        var hd = headerEl();
        if (hd) nodes = [hd];
      }
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.classList && el.classList.contains('shopify-section-header-hidden')) continue;
        var r = el.getBoundingClientRect();
        if (r.height < 1) continue;
        if (r.bottom > maxBottom) maxBottom = r.bottom;
      }
      return Math.max(0, Math.round(maxBottom));
    }
    function syncQnTop() {
      qn.style.top = headerBottom() + 'px';
    }
    function qOff() {
      return headerBottom() + qn.offsetHeight + 8;
    }
    function qs() {
      syncQnTop();
      if (weeks) {
        var r = weeks.getBoundingClientRect();
        qn.classList.toggle('on', r.bottom < headerBottom());
      }
      var y = qOff() + 40;
      var act = null;
      qa.forEach(function (a) {
        var t = document.getElementById(a.dataset.qn);
        if (t && t.getBoundingClientRect().top <= y) act = a;
      });
      qa.forEach(function (a) {
        a.classList.toggle('cur', a === act);
      });
      if (act) {
        var p = act.parentNode;
        var l = act.offsetLeft - p.clientWidth / 2 + act.offsetWidth / 2;
        p.scrollTo({ left: l, behavior: 'smooth' });
      }
    }
    addEventListener('scroll', qs, { passive: true });
    addEventListener('resize', qs);
    qs();
    qn.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-qn]');
      if (!a) return;
      e.preventDefault();
      var t = document.getElementById(a.dataset.qn);
      if (t) window.scrollTo({ top: t.getBoundingClientRect().top + scrollY - qOff(), behavior: 'smooth' });
    });
  }

  // 清掉 Klaviyo 注入的白底（只改一次，避免 MutationObserver 死循环卡死页面）
  function clearKlaviyoWhiteBg(root) {
    if (!root) return;
    var nodes = root.querySelectorAll('[class*="klaviyo-form-"], [class*="klaviyo-form-"] *, form.klaviyo-form, form.klaviyo-form *');
    nodes.forEach(function (el) {
      if (el.getAttribute('data-bfcm-klv-bg') === '1') return;
      var tag = (el.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'button' || tag === 'select') return;
      if (el.style) {
        el.style.setProperty('background', 'transparent', 'important');
        el.style.setProperty('background-color', 'transparent', 'important');
        el.style.setProperty('background-image', 'none', 'important');
        el.setAttribute('data-bfcm-klv-bg', '1');
      }
    });
  }

  // Notify 弹窗输入框：Klaviyo 可能用内联 !important 写白底，
  // CSS 无法盖过内联 important，只能用同样带 important 的内联样式覆盖
  function paintNotifyInputs(root) {
    var scope = root || document;
    var inputs = scope.querySelectorAll(
      '.bfcm2026 .nm .nm-klaviyo input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"])'
    );
    if (!inputs.length) return;

    // 常规态与聚焦态两套描边，底色始终透明
    var IDLE_BORDER = '1.5px solid rgba(255,255,255,.30)';
    var FOCUS_BORDER = '1.5px solid #CDB4FF';
    var IDLE_SHADOW = 'none';
    var FOCUS_SHADOW = '0 0 0 3px rgba(160,120,255,.18)';

    function apply(el, border, shadow) {
      if (!el.style) return;
      el.style.setProperty('background', 'transparent', 'important');
      el.style.setProperty('background-color', 'transparent', 'important');
      el.style.setProperty('background-image', 'none', 'important');
      el.style.setProperty('border', border, 'important');
      el.style.setProperty('border-radius', '999px', 'important');
      el.style.setProperty('box-shadow', shadow, 'important');
      el.style.setProperty('color', '#fff', 'important');
      el.style.setProperty('-webkit-text-fill-color', '#fff', 'important');
    }

    inputs.forEach(function (el) {
      // 已处理且内联样式还在，就不重复写，避免无谓重排
      if (el.getAttribute('data-bfcm-klv-input') === '1' && el.style.backgroundColor) return;
      apply(el, IDLE_BORDER, IDLE_SHADOW);
      el.setAttribute('data-bfcm-klv-input', '1');
      // 只绑一次聚焦/失焦，切换描边颜色
      if (el.getAttribute('data-bfcm-klv-focus') !== '1') {
        el.addEventListener('focus', function () {
          apply(el, FOCUS_BORDER, FOCUS_SHADOW);
        });
        el.addEventListener('blur', function () {
          apply(el, IDLE_BORDER, IDLE_SHADOW);
        });
        el.setAttribute('data-bfcm-klv-focus', '1');
      }
    });
  }

  function initKlaviyoSkin() {
    var roots = document.querySelectorAll('.bfcm2026 .ga-klaviyo, .bfcm2026 .nm-klaviyo');
    if (!roots.length) return;

    function scrubAll() {
      roots.forEach(clearKlaviyoWhiteBg);
      // 弹窗里的输入框也可能被 Klaviyo 内联白底覆盖，一并重涂
      paintNotifyInputs(document);
    }
    scrubAll();

    // 只监听新增节点，不监听 style（改 style 会再次触发，造成死循环）
    var timer = null;
    var mo = new MutationObserver(function (mutations) {
      var hasNew = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          hasNew = true;
          break;
        }
      }
      if (!hasNew) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(scrubAll, 100);
    });
    roots.forEach(function (r) {
      mo.observe(r, { childList: true, subtree: true });
    });
    setTimeout(scrubAll, 1000);
    setTimeout(scrubAll, 3000);
  }

  // Notify 弹窗：按来源模块切换对应 Klaviyo 表单
  function initNotify() {
    var nm = document.getElementById('nm');
    if (!nm) return;

    // 从按钮或所在区块推断表单 key：combo / mystery / flash
    function resolveNotifyKey(btn) {
      var key = (btn.getAttribute('data-notify') || '').trim();
      if (key && key !== 'true') return key;
      if (btn.closest('#bundle')) return 'combo';
      if (btn.closest('#blindbox')) return 'mystery';
      if (btn.closest('#flash')) return 'flash';
      return 'default';
    }

    function showNotifyForm(key) {
      var forms = nm.querySelectorAll('[data-nm-form]');
      if (!forms.length) return;
      var shown = false;
      forms.forEach(function (el) {
        var match = el.getAttribute('data-nm-form') === key;
        el.hidden = !match;
        if (match) shown = true;
      });
      // 无匹配表单时回退到 default，再不行显示第一个
      if (!shown) {
        var fallback = nm.querySelector('[data-nm-form="default"]') || forms[0];
        forms.forEach(function (el) {
          el.hidden = el !== fallback;
        });
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-notify]');
      if (btn) {
        e.preventDefault();
        showNotifyForm(resolveNotifyKey(btn));
        nm.hidden = false;
        // 弹窗打开后再清一次白底（表单可能刚显示）
        var active = nm.querySelector('[data-nm-form]:not([hidden])');
        clearKlaviyoWhiteBg(active || nm);
        paintNotifyInputs(nm);
        var i = nm.querySelector('[data-nm-form]:not([hidden]) input, [data-nm-form]:not([hidden]) [contenteditable], input, [contenteditable]');
        if (i && i.focus) setTimeout(function () {
          i.focus();
        }, 50);
        return;
      }
      if (e.target.closest('[data-nmx]') || e.target === nm) nm.hidden = true;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') nm.hidden = true;
    });
  }

  // Bundle：从 DOM data 属性组装选择器
  function initBundle() {
    var app = document.getElementById('bsApp');
    if (!app) return;
    var railEl = document.getElementById('bsRail');
    if (!railEl) return;

    // 从区块输出的 JSON 读取可选商品
    var dataEl = document.getElementById('bfcm2026-bundle-data');
    var D = { kb: [], ms: [], hs: [] };
    if (dataEl) {
      try {
        D = JSON.parse(dataEl.textContent);
      } catch (e) {}
    }

    var sel = { kb: null, ms: null, hs: null };
    var vs = {};
    var cur = 'kb';
    var busy = false;
    var railW = railEl.parentNode;
    var discPct = Number(D.discount) || 25;

    // 金额按店铺 money_format 输出。Transcy 会把 format 包成 HTML，
    // 这里先剥掉标签，只留 $119.98 这种纯文本，避免小计里露出 <span>。
    function f(n) {
      var fmt = String(D.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '').trim() || '${{amount}}';
      var val = Number(n);
      if (isNaN(val)) val = 0;
      var neg = val < 0;
      val = Math.abs(val);
      var parts = val.toFixed(2).split('.');
      var d = parts[0];
      var c = parts[1];
      var withComma = d.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + c;
      var out = fmt
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, d.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, d)
        .replace(/\{\{\s*amount\s*\}\}/g, d + '.' + c);
      return (neg ? '-' : '') + out;
    }
    function moneyHtml(n, prefix) {
      return (prefix || '') + '<span class="transcy-money">' + f(n) + '</span>';
    }
    function priceText(v) {
      var raw = (v && v.price_text) || f((v && v.price) || 0);
      return String(raw).replace(/<[^>]*>/g, '').trim() || f(0);
    }
    function find(c, id) {
      return (D[c] || []).filter(function (p) {
        return p.id === id;
      })[0];
    }
    function vr(p) {
      if (!p || !p.variants || !p.variants.length) return { price: 0, image: '', label: '', id: '' };
      var i = vs[p.id] || 0;
      return p.variants[i] || p.variants[0];
    }

    // 加购用当前选中的变体 ID（下拉切过颜色就加那个）
    function variantIdFor(p) {
      var v = vr(p);
      return v && v.id ? String(v.id) : '';
    }

    function slots() {
      app.querySelectorAll('.bs-slot').forEach(function (el) {
        var c = el.dataset.s;
        if (c === 'ms' && !sel.ms && sel.hs) c = 'hs';
        var p = sel[c] && find(c, sel[c]);
        var v = p && vr(p);
        el.classList.toggle('full', !!p);
        // 空格子整块可点，所以给它 role="button" + tabindex="0"，Tab 能走到、回车能触发；
        // 已选中的格子内部有真正的 <button class="bs-x">，再套一层 role="button"
        // 会造成「按钮里嵌按钮」，所以这里把 role/tabindex 摘掉，只留那个 × 可聚焦。
        if (p) {
          el.removeAttribute('role');
          el.removeAttribute('tabindex');
          el.removeAttribute('aria-label');
        } else {
          el.setAttribute('role', 'button');
          el.setAttribute('tabindex', '0');
          el.setAttribute(
            'aria-label',
            c === 'kb' ? 'Add a keyboard' : 'Add a mouse or headset'
          );
        }
        el.innerHTML = p
          ? '<button type="button" class="bs-x" data-rm="' +
            c +
            '" aria-label="Remove">×</button><span class="bs-sim c-' +
            c +
            '"><img src="' +
            (v.image || '') +
            '" alt=""></span><b>' +
            p.title +
            (v.label ? ' · ' + v.label : '') +
            '</b><span>' +
            priceText(v) +
            '</span>'
          : '<span class="bs-plus">+</span><b>' +
            (c === 'kb' ? 'Add a Keyboard' : 'Add a Mouse or Headset') +
            '</b><span>' +
            (c === 'kb' ? 'Required' : 'Pick one') +
            '</span>';
      });
      var sub = 0;
      ['kb', 'ms', 'hs'].forEach(function (c) {
        if (sel[c]) sub += vr(find(c, sel[c])).price;
      });
      var ok = sel.kb && (sel.ms || sel.hs);
      var off = ok ? sub * (discPct / 100) : 0;
      var bsSub = document.getElementById('bsSub');
      var bsOff = document.getElementById('bsOff');
      var bsTot = document.getElementById('bsTot');
      var bsCta = document.getElementById('bsCta');
      var bsHint = document.getElementById('bsHint');
      if (bsSub) bsSub.innerHTML = moneyHtml(sub);
      if (bsOff) bsOff.innerHTML = moneyHtml(off, '-');
      if (bsTot) bsTot.innerHTML = moneyHtml(sub - off);
      if (bsCta) bsCta.setAttribute('aria-disabled', ok && !busy ? 'false' : 'true');
      if (bsHint) {
        bsHint.textContent = ok
          ? discPct + '% off applied automatically at checkout.'
          : sel.kb
            ? 'Add a mouse or headset to unlock ' + discPct + '% off.'
            : 'Pick 1 keyboard + 1 mouse or headset to unlock ' + discPct + '% off.';
      }
    }

    function navs() {
      var o = railEl.scrollWidth > railEl.clientWidth + 4;
      railW.classList.toggle('scroll', o);
      var prev = railW.querySelector('.prev');
      var next = railW.querySelector('.next');
      if (prev) prev.disabled = railEl.scrollLeft < 4;
      if (next) next.disabled = railEl.scrollLeft + railEl.clientWidth >= railEl.scrollWidth - 4;
    }

    function rail(keep) {
      var x = railEl.scrollLeft;
      railEl.innerHTML = (D[cur] || [])
        .map(function (p) {
          var v = vr(p);
          var on = sel[cur] === p.id;
          var vi = vs[p.id] || 0;
          var sw =
            p.variants.length > 1
              ? '<label class="bs-sel"><span class="sr">Version</span><select data-vs="' +
                p.id +
                '" aria-label="Choose color / layout">' +
                p.variants
                  .map(function (o, i) {
                    return (
                      '<option value="' +
                      i +
                      '"' +
                      (i === vi ? ' selected' : '') +
                      '>' +
                      (o.label || 'Default') +
                      '</option>'
                    );
                  })
                  .join('') +
                '</select></label>'
              : '';
          return (
            '<div class="bs-card c-' +
            cur +
            (on ? ' on' : '') +
            '"><a class="bs-img" href="' +
            (p.url || '#') +
            '" target="_blank" rel="noopener"><img src="' +
            (v.image || '') +
            '" alt="' +
            p.title +
            '" loading="lazy"></a><p class="bs-n">' +
            p.title +
            '</p><div class="bs-pr"><p class="bs-p">' +
            priceText(v) +
            '</p>' +
            sw +
            '</div><button class="btn ' +
            (on ? 'btn-holo' : 'btn-line') +
            ' btn-sm" data-add="' +
            p.id +
            '">' +
            (on ? 'Added ✓' : 'Add to Set') +
            '</button></div>'
          );
        })
        .join('');
      railEl.scrollLeft = keep ? x : 0;
      navs();
    }

    function go(c) {
      cur = c;
      app.querySelectorAll('.bs-tabs button').forEach(function (b) {
        b.classList.toggle('on', b.dataset.c === c);
      });
      app.querySelectorAll('.bs-slot').forEach(function (s) {
        s.classList.toggle('cur', s.dataset.s === c || (s.dataset.s === 'ms' && c === 'hs'));
      });
      rail();
    }

    railEl.addEventListener('scroll', navs, { passive: true });
    addEventListener('resize', navs);
    railW.addEventListener('click', function (e) {
      var b = e.target.closest('.bs-nav');
      if (!b) return;
      railEl.scrollBy({
        left: (b.classList.contains('next') ? 1 : -1) * railEl.clientWidth * 0.8,
        behavior: 'smooth',
      });
    });

    app.addEventListener('change', function (e) {
      var s = e.target.closest('[data-vs]');
      if (!s) return;
      vs[s.dataset.vs] = +s.value;
      rail(1);
      if (sel[cur] === s.dataset.vs) slots();
    });

    app.addEventListener('click', function (e) {
      // 先处理格子上的 ×：产品图会盖住按钮，不能跟 .bs-slot 混在同一个 closest 里
      var rm = e.target.closest('[data-rm]');
      if (rm && app.contains(rm)) {
        e.preventDefault();
        e.stopPropagation();
        sel[rm.getAttribute('data-rm')] = null;
        slots();
        rail(1);
        return;
      }
      var t = e.target.closest('[data-add],[data-c],.bs-slot');
      if (!t) return;
      if (t.dataset.add) {
        sel[cur] = sel[cur] === t.dataset.add ? null : t.dataset.add;
        if (sel[cur] && cur === 'ms') sel.hs = null;
        if (sel[cur] && cur === 'hs') sel.ms = null;
        slots();
        rail(1);
        if (cur === 'kb' && sel.kb) go('ms');
        return;
      }
      if (t.dataset.c) {
        go(t.dataset.c);
        return;
      }
      if (t.classList.contains('bs-slot')) {
        go(t.dataset.s === 'ms' && sel.hs ? 'hs' : t.dataset.s);
      }
    });

    // 空格子用 div + role="button" 实现（格子内部还要放删除按钮，不能真的用 <button>），
    // 所以键盘的 Enter / 空格要手动转成 click，否则 Tab 到了却按不动。
    app.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var t = e.target.closest('.bs-slot[role="button"]');
      if (!t || e.target !== t) return;
      e.preventDefault(); // 空格默认会滚动页面
      t.click();
    });

    // 「Add Set to Cart」：把选中的两件真加进购物车，然后展开侧边购物车
    var cta = document.getElementById('bsCta');
    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        if (busy) return;
        var kb = sel.kb && find('kb', sel.kb);
        var other = sel.ms ? find('ms', sel.ms) : sel.hs ? find('hs', sel.hs) : null;
        if (!kb || !other) {
          toast('Pick 1 keyboard + 1 mouse or headset first');
          return;
        }
        var picks = [kb, other];
        var vids = picks.map(variantIdFor);
        // 有商品没绑定后台产品时无法加购，直接提示，不半截加进去
        if (vids.some(function (v) { return !v; })) {
          toast('This set isn\u2019t linked to a product yet');
          return;
        }
        setBusy(true);
        addCartItems(
          vids.map(function (id) {
            return { id: Number(id), quantity: 1 };
          })
        )
          .then(function (state) {
            announceCartUpdate('bfcm2026-bundle', state);
            return openCartDrawer(state);
          })
          .catch(function (err) {
            console.error(err);
            toast('Could not add the set, please try again');
          })
          .then(function () {
            setBusy(false);
          });
      });
    }

    // 按钮 loading 态：避免连点重复加购
    function setBusy(on) {
      busy = on;
      if (!cta) return;
      cta.classList.toggle('loading', on);
      cta.setAttribute('aria-disabled', on ? 'true' : sel.kb && (sel.ms || sel.hs) ? 'false' : 'true');
      cta.textContent = on ? 'Adding\u2026' : 'Add Set to Cart';
    }

    slots();
    go('kb');

    // 推荐组合「Add Combo to Cart」：一次加两件，再打开侧边购物车
    initComboAtc();

    // 轨道圆点
    (function () {
      var d = document.createElement('div');
      d.className = 'bs-dots';
      railEl.parentNode.after(d);
      function up() {
        if (!railEl.clientWidth) {
          d.style.display = 'none';
          return;
        }
        var n = Math.min(20, Math.max(1, Math.ceil(railEl.scrollWidth / railEl.clientWidth - 0.05) || 1));
        var i = Math.round(
          (railEl.scrollLeft / Math.max(1, railEl.scrollWidth - railEl.clientWidth)) * (n - 1)
        );
        if (d.children.length !== n) d.innerHTML = Array(n + 1).join('<i></i>');
        [].forEach.call(d.children, function (e, k) {
          e.classList.toggle('on', k === i);
        });
        d.style.display = n > 1 ? '' : 'none';
      }
      railEl.addEventListener('scroll', up, { passive: true });
      addEventListener('resize', up);
      new MutationObserver(up).observe(railEl, { childList: true });
      requestAnimationFrame(up);
    })();
  }

  // 推荐组合加购：按钮上带两件商品的变体 ID
  function initComboAtc() {
    var grid = document.getElementById('cbGrid');
    if (!grid) return;
    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bfcm-combo-atc]');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('loading') || btn.getAttribute('aria-disabled') === 'true') return;
      var vids = [btn.getAttribute('data-vid-kb'), btn.getAttribute('data-vid-ms')].filter(Boolean);
      if (vids.length < 2) {
        toast('This combo isn\u2019t linked to a product yet');
        return;
      }
      var label = btn.textContent;
      btn.classList.add('loading');
      btn.setAttribute('aria-disabled', 'true');
      btn.textContent = 'Adding\u2026';
      addCartItems(
        vids.map(function (id) {
          return { id: Number(id), quantity: 1 };
        })
      )
        .then(function (state) {
          announceCartUpdate('bfcm2026-combo', state);
          return openCartDrawer(state);
        })
        .catch(function (err) {
          console.error(err);
          toast('Could not add the combo, please try again');
        })
        .then(function () {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
          btn.textContent = label;
        });
    });
  }

  // Product Finder：题目与结果池来自 JSON
  function initFinder() {
    var el = document.getElementById('fd');
    var dataEl = document.getElementById('bfcm2026-finder-data');
    if (!el || !dataEl) return;
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var Q = data.questions || [];
    var pool = data.pool || [];
    var step = 0;
    var ans = {};

    // Finder 选项图标（与设计稿 IC 一致，icon 字段传 key）
    var IC = {
      pad:
        '<path d="M7 8h10a4 4 0 0 1 3.9 3.1l.9 4.3a2.4 2.4 0 0 1-4.2 2L16 16H8l-1.6 1.4a2.4 2.4 0 0 1-4.2-2l.9-4.3A4 4 0 0 1 7 8z"/><path d="M7.5 11v3M6 12.5h3"/><circle cx="15.5" cy="11.6" r=".6" class="f"/><circle cx="17.3" cy="13.4" r=".6" class="f"/>',
      laptop: '<rect x="5" y="5.5" width="14" height="9.5" rx="1.4"/><path d="M2.5 18.5h19l-1.2-2.5H3.7z"/>',
      monitor:
        '<path d="M9 17.5V6.5l10-2.2v10.8"/><path d="M9 9.6l10-2.2"/><ellipse cx="6.6" cy="17.6" rx="2.6" ry="2.1" class="f"/><ellipse cx="16.6" cy="15.2" rx="2.6" ry="2.1" class="f"/>',
      leaf:
        '<path d="M19.5 4.5C10 4.5 5 9 5 15.5c0 1.4.4 2.6 1 3.5 6.5 0 13.5-4 13.5-14.5z" class="f2"/><path d="M5.5 19.5c3-4.5 6.5-7.5 10-9.5"/>',
      kb60:
        '<rect x="5" y="8" width="14" height="8" rx="1.5"/><path d="M8 11h.01M11 11h.01M14 11h.01M16.5 11h.01M9 13.5h6"/>',
      kb75:
        '<rect x="3.5" y="7.5" width="17" height="9" rx="1.5"/><path d="M6.5 10.5h.01M9.5 10.5h.01M12.5 10.5h.01M15.5 10.5h.01M18 10.5h.01M8 13.5h8M17.5 13.5h.01"/>',
      kb100:
        '<rect x="1.5" y="7" width="21" height="10" rx="1.5"/><path d="M4.5 10h.01M7.5 10h.01M10.5 10h.01M13.5 10h.01M16.5 10v4.5M19.5 10h.01M19.5 13h.01M6 13.5h8"/>',
      spark:
        '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/><path d="M18.5 15.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z" class="f"/>',
      tag: '<path d="M3.5 12.2V4.5a1 1 0 0 1 1-1h7.7l8.3 8.3a1.4 1.4 0 0 1 0 2l-6.7 6.7a1.4 1.4 0 0 1-2 0z"/><circle cx="8" cy="8" r="1.4"/>',
      coins:
        '<ellipse cx="9" cy="7" rx="5.5" ry="2.5"/><path d="M3.5 7v4c0 1.4 2.5 2.5 5.5 2.5M3.5 11v4c0 1.4 2.5 2.5 5.5 2.5"/><ellipse cx="15.5" cy="13.5" rx="5" ry="2.3"/><path d="M10.5 13.5v3.5c0 1.3 2.2 2.3 5 2.3s5-1 5-2.3v-3.5"/>',
      gem: '<path d="M6.5 4h11l3.5 5-9 11-9-11z"/><path d="M3 9h18M9 4l3 16 3-16"/>',
    };

    // 按 icon key 输出渐变描边 SVG；已是 SVG 字符串则原样返回
    function ic(k) {
      if (!k) return '';
      if (k.indexOf('<svg') === 0) return k;
      if (!IC[k]) return '';
      return '<svg viewBox="0 0 24 24" aria-hidden="true">' + IC[k] + '</svg>';
    }

    function inBud(p, b) {
      return b === 'lo' ? p < 60 : b === 'mid' ? p >= 60 && p <= 80 : p > 80;
    }

    function results() {
      return pool
        .map(function (item) {
          var sc = 0;
          if (item.use === ans.use) sc += 3;
          if (ans.size === 'any' ? item.popular : item.size === ans.size) sc += 2;
          if (inBud(item.price, ans.bud)) sc += 2.5;
          else sc -= Math.abs(item.price - (ans.bud === 'lo' ? 55 : ans.bud === 'mid' ? 70 : 100)) / 40;
          return { item: item, sc: sc };
        })
        .sort(function (a, b) {
          return b.sc - a.sc;
        })
        .slice(0, 3)
        .map(function (x) {
          return x.item;
        });
    }

    // 结果卡：价格由 Liquid 端预先算好（自定义价 or 自动产品价），
    // 两边都为空时不渲染价格块，避免出现空的价签
    function priceHtml(item) {
      if (!item.sale_price) return '';
      return (
        '<div class="pc-p" role="img" aria-label="Sale price ' +
        item.sale_price +
        (item.compare_price ? ', original price ' + item.compare_price : '') +
        '"><ins class="pc-now"><b class="gold">' +
        item.sale_price +
        '</b></ins>' +
        (item.compare_price
          ? '<del class="pc-was"><s>' + item.compare_price + '</s></del>'
          : '') +
        '</div>'
      );
    }

    function cardHtml(item) {
      return (
        '<article class="pc"><span class="tag tag-sale">' +
        (item.tag || '20% Off') +
        '</span><a class="pc-img" href="' +
        (item.url || '#') +
        '"><img src="' +
        (item.image || '') +
        '" alt="' +
        (item.title || '') +
        '" loading="lazy"></a><div class="pc-b"><h3 class="pc-t"><a href="' +
        (item.url || '#') +
        '">' +
        (item.title || '') +
        '</a></h3>' +
        priceHtml(item) +
        (item.note ? '<div class="pc-n">' + item.note + '</div>' : '') +
        '<div class="pc-a"><a class="btn btn-line" href="' +
        (item.url || '#') +
        '">Add to Cart</a><a class="btn btn-gold" href="' +
        (item.url || '#') +
        '">Buy Now</a></div></div></article>'
      );
    }

    function rf() {
      if (step < Q.length) {
        var q = Q[step];
        el.innerHTML =
          '<div class="fd-prog"><b>' +
          (step + 1) +
          ' of ' +
          Q.length +
          '</b><i style="--p:' +
          ((step + 1) / Q.length) * 100 +
          '%"></i></div><h3>' +
          q.q +
          '</h3><div class="fd-opts ' +
          (q.o.length === 3 ? 'c3' : '') +
          '">' +
          q.o
            .map(function (o) {
              return (
                '<button type="button" class="opt ' +
                (ans[q.k] === o.v ? 'on' : '') +
                '" data-v="' +
                o.v +
                '"><span class="opt-ic">' +
                ic(o.icon) +
                '</span><b>' +
                o.label +
                '</b>' +
                (o.desc ? '<span>' + o.desc + '</span>' : '') +
                '</button>'
              );
            })
            .join('') +
          '</div><div class="fd-nav">' +
          (step ? '<button class="lnk" data-back>← Back</button>' : '<span></span>') +
          '<span style="color:var(--mute2);font-size:14px">Pick one to continue</span></div>';
      } else {
        el.innerHTML =
          '<div class="fd-prog"><b>Your picks</b><i style="--p:100%"></i></div><h3>Top matches for you</h3><div class="fd-res">' +
          results().map(cardHtml).join('') +
          '</div><div class="fd-nav"><button class="lnk" data-back>← Back</button><button class="btn btn-line btn-sm" data-reset>Start Over</button></div>';
      }
    }

    el.addEventListener('click', function (e) {
      var o = e.target.closest('.opt');
      if (o) {
        ans[Q[step].k] = o.dataset.v;
        rf();
        setTimeout(function () {
          step++;
          rf();
        }, 220);
        return;
      }
      if (e.target.closest('[data-back]')) {
        step = Math.max(0, step - 1);
        rf();
      }
      if (e.target.closest('[data-reset]')) {
        step = 0;
        ans = {};
        rf();
      }
    });
    rf();
  }

  // 评价横向滚动圆点
  function initReviewDots() {
    var r = document.getElementById('jmGrid');
    if (!r) return;
    var d = document.createElement('div');
    d.className = 'rv-dots';
    r.after(d);
    function up() {
      if (!r.clientWidth) {
        d.style.display = 'none';
        return;
      }
      var n = Math.min(20, Math.max(1, Math.ceil(r.scrollWidth / r.clientWidth - 0.05) || 1));
      var i = Math.round((r.scrollLeft / Math.max(1, r.scrollWidth - r.clientWidth)) * (n - 1));
      if (d.children.length !== n) d.innerHTML = Array(n + 1).join('<i></i>');
      [].forEach.call(d.children, function (e, k) {
        e.classList.toggle('on', k === i);
      });
      d.style.display = n > 1 ? '' : 'none';
    }
    r.addEventListener('scroll', up, { passive: true });
    addEventListener('resize', up);
    requestAnimationFrame(up);
  }

  // Hero 指针特效（桌面）
  function initHeroFx() {
    var hr = document.querySelector('.hero.hx');
    if (!hr || matchMedia('(hover:none)').matches) return;
    if (!matchMedia('(prefers-reduced-motion:reduce)').matches) {
      var K = ['st', 'ht', 'dot', 'pc', 'st', 'ht'];
      var C = ['#FFB3E6', '#C9A6FF', '#8EC5FF', '#8FF0D8', '#FFF2A8'];
      var last = 0;
      var n = 0;
      hr.addEventListener('pointermove', function (e) {
        var t = performance.now();
        if (t - last < 55 || n > 36) return;
        last = t;
        var r = hr.getBoundingClientRect();
        var el = document.createElement('i');
        el.className = 'hx-fall ' + K[(Math.random() * K.length) | 0];
        if (el.classList.contains('pc')) el.textContent = '%';
        el.style.left = e.clientX - r.left + 'px';
        el.style.top = e.clientY - r.top + 'px';
        el.style.setProperty('--c', C[(Math.random() * C.length) | 0]);
        el.style.setProperty('--dx', (Math.random() * 80 - 40).toFixed(0) + 'px');
        el.style.setProperty('--rt', (Math.random() * 360 - 180).toFixed(0) + 'deg');
        el.style.setProperty('--sz', (10 + Math.random() * 12).toFixed(0) + 'px');
        hr.appendChild(el);
        n++;
        el.addEventListener('animationend', function () {
          el.remove();
          n--;
        });
      });
    }
    var tx = 0;
    var ty = 0;
    var cx = 0;
    var cy = 0;
    var raf;
    hr.addEventListener('pointermove', function (e) {
      var r = hr.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width - 0.5;
      ty = (e.clientY - r.top) / r.height - 0.5;
      hr.style.setProperty('--sx', e.clientX - r.left + 'px');
      hr.style.setProperty('--sy', e.clientY - r.top + 'px');
      hr.classList.add('on');
      if (!raf) loop();
    });
    hr.addEventListener('pointerleave', function () {
      tx = ty = 0;
      hr.classList.remove('on');
    });
    function loop() {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      hr.style.setProperty('--px', cx.toFixed(4));
      hr.style.setProperty('--py', cy.toFixed(4));
      raf = Math.abs(tx - cx) + Math.abs(ty - cy) > 0.0005 ? requestAnimationFrame(loop) : 0;
    }
    hr.addEventListener('pointermove', function (e) {
      hr.querySelectorAll('.hx-a').forEach(function (t) {
        var r = t.getBoundingClientRect();
        t.style.setProperty('--mx', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
        t.style.setProperty('--my', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
      });
    });
  }

  // 优惠券 3D / 高光跟随（对齐设计包 shopify-package）
  function initTicketFx() {
    var t = document.getElementById('swTkt');
    if (!t || matchMedia('(hover:none)').matches) return;
    t.addEventListener('pointermove', function (e) {
      var r = t.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      var y = (e.clientY - r.top) / r.height;
      t.style.setProperty('--mx', x * 100 + '%');
      t.style.setProperty('--my', y * 100 + '%');
      t.style.setProperty('--rx', (0.5 - y) * 10 + 'deg');
      t.style.setProperty('--ry', (x - 0.5) * 12 + 'deg');
    });
    t.addEventListener('pointerleave', function () {
      t.style.setProperty('--rx', '0deg');
      t.style.setProperty('--ry', '0deg');
    });
  }

  // 移动端产品图视觉对齐
  function initImgFit() {
    var mq = matchMedia('(max-width:760px)');
    var cache = {};
    function bbox(img) {
      var s = img.currentSrc || img.src;
      if (cache[s]) return cache[s];
      var w = 200;
      var h = Math.max(1, Math.round((200 * img.naturalHeight) / img.naturalWidth));
      var cv = document.createElement('canvas');
      cv.width = w;
      cv.height = h;
      var x = cv.getContext('2d');
      try {
        x.drawImage(img, 0, 0, w, h);
        var d = x.getImageData(0, 0, w, h).data;
      } catch (e) {
        return null;
      }
      var rows = [];
      var mx = 0;
      for (var y = 0; y < h; y++) {
        var n = 0;
        var L = w;
        var R = -1;
        for (var i = 0; i < w; i++) {
          if (d[(y * w + i) * 4 + 3] > 128) {
            n++;
            if (i < L) L = i;
            R = i;
          }
        }
        rows.push([n, L, R]);
        if (n > mx) mx = n;
      }
      if (!mx) return null;
      var t = -1;
      var b = -1;
      var l = w;
      var r = -1;
      for (var y2 = 0; y2 < h; y2++) {
        if (rows[y2][0] > mx * 0.4) {
          if (t < 0) t = y2;
          b = y2;
          if (rows[y2][1] < l) l = rows[y2][1];
          if (rows[y2][2] > r) r = rows[y2][2];
        }
      }
      return (cache[s] = { l: l / w, t: t / h, r: (r + 1) / w, b: (b + 1) / h });
    }
    function fit(img) {
      if (!img.complete || !img.naturalWidth) return;
      if (!mq.matches) {
        img.style.removeProperty('transform');
        return;
      }
      var bb = bbox(img);
      if (!bb) return;
      var bw = img.clientWidth;
      var bh = img.clientHeight;
      var nr = img.naturalWidth / img.naturalHeight;
      var rw;
      var rh;
      if (bw / bh > nr) {
        rh = bh;
        rw = bh * nr;
      } else {
        rw = bw;
        rh = bw / nr;
      }
      var ox = (bw - rw) / 2;
      var oy = (bh - rh) / 2;
      var vw = (bb.r - bb.l) * rw;
      var vh = (bb.b - bb.t) * rh;
      var cx = ox + ((bb.l + bb.r) / 2) * rw;
      var cy = oy + ((bb.t + bb.b) / 2) * rh;
      var s = (bw * 0.86) / vw;
      if (vh * s > bh * 0.95) s = (bh * 0.95) / vh;
      img.style.setProperty('transform-origin', '0 0', 'important');
      img.style.setProperty(
        'transform',
        'translate(' + (bw / 2 - cx * s) + 'px,' + (bh / 2 - cy * s) + 'px) scale(' + s + ')',
        'important'
      );
    }
    function run() {
      document
        .querySelectorAll('.sw-grid .pc-img img,.fl-grid .pc-img img,.nw-grid .pc-img img,.pts-g .pc-img img')
        .forEach(function (i) {
          if (!i.__fit) {
            i.__fit = 1;
            i.addEventListener('load', function () {
              fit(i);
            });
          }
          fit(i);
        });
    }
    var tm;
    function q() {
      clearTimeout(tm);
      tm = setTimeout(run, 60);
    }
    new MutationObserver(q).observe(document.body, { childList: true, subtree: true });
    addEventListener('resize', q);
    if (mq.addEventListener) mq.addEventListener('change', q);
    if (document.readyState === 'complete') run();
    else addEventListener('load', run);
    q();
  }

  function init() {
    // 确保全页深色背景标记（壳层也会加；此处兜底）
    document.documentElement.classList.add('bfcm2026-page');
    var cfg = getConfig();
    syncRoots(cfg);
    applyStates(cfg.dealState || 'auto');
    window.applyStates = applyStates;
    initCountdown(cfg);
    initCopy();
    initTabs();
    initBfcmAtc();
    initJumpNav();
    initMemberLoginReturn();
    initSmileRedeem();
    initNotify();
    initKlaviyoSkin();
    initBundle();
    initFinder();
    initReviewDots();
    initHeroFx();
    initTicketFx();
    initImgFit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
